import clsx from 'clsx';
import * as React from 'react';
import { MouseEvent, ReactElement, useState } from 'react';

export interface CheckboxProps {
  className?: string;
  label?: ReactElement | string;
  value: boolean;
  onChange: (value: boolean) => void;
  disabled?: boolean;
  withBackground?: boolean;
  style?: React.CSSProperties;
}

/**
 * Компонент флажка; состояние управляется только извне.
 *
 * [Ссылка на макет](https://www.figma.com/design/GA8mTdovVruI98nkpMCxvV/%D0%91%D0%B0%D0%B7%D0%BE%D0%B2%D1%8B%D0%B5-%D0%BA%D0%BE%D0%BC%D0%BF%D0%BE%D0%BD%D0%B5%D0%BD%D1%82%D1%8B?node-id=61-355&t=r7fvQ58ZuchL0voh-4)
 */
export const Checkbox: React.FC<CheckboxProps> = (props) => {
  const [clicked, setClicked] = useState(false);

  const handleClick = (event: MouseEvent) => {
    event.stopPropagation();
    props.onChange(!props.value);
    setClicked(true);
    setTimeout(() => setClicked(false), 200);
  };

  return (
    <div
      className={clsx(
        'checkbox__wrapper',
        props.disabled && 'checkbox__wrapper-disabled',
        clicked && 'clicked',
        props.className
      )}
      style={props.style}
      onClick={handleClick}
    >
      <div
        className={clsx(
          'checkbox__input',
          props.value && 'checkbox__input-checked',
          props.disabled && 'checkbox__input-disabled',
          props.withBackground && 'checkbox__input-with_background'
        )}
      >
        <div className={'checkbox__checkmark-first'} />
        <div className={'checkbox__checkmark-second'} />
      </div>
      {props.label && <div className={'checkbox__label'}>{props.label}</div>}
    </div>
  );
};
